// extracted by mini-css-extract-plugin
export default {"parent":"Works_parent__mNyL6","text":"Works_text__oYqIc","container":"Works_container__uNiBJ"};